// extracted by mini-css-extract-plugin
export default {"resultsContainer":"CheckLineResultInfo_resultsContainer__YxiQY","good":"CheckLineResultInfo_good__Jcc+s","bad":"CheckLineResultInfo_bad__FDnSt"};